<template>
  <el-container>
    
    <el-aside width="250px">
      <div class="el-aside__logo"></div>
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        background-color="#304156"
        text-color="#fff"
        @select="changeSidebar"
        active-text-color="#4980ff">

        <!-- 一级菜单项 -->
        <!-- <el-submenu index="访客预约管理">
          <template #title>
            <span>访客预约管理</span>
          </template>
          <el-menu-item index="MyMessage">
            <i class="el-icon-document"></i>
            <span slot="title">访客帮填登记表</span>
          </el-menu-item>
          <el-menu-item index="OwnWrite">
            <i class="el-icon-s-check"></i>
            <span slot="title">访客自行填写</span>
          </el-menu-item>
        </el-submenu> -->
        <el-submenu index="访客表单管理">
          <template #title>
            <span>访客表单管理</span>
          </template>
          <el-menu-item index="shenpi">
            <i class="el-icon-s-shop"></i>
            <span slot="title">访客自填表单详情页</span>
          </el-menu-item>
          <el-menu-item index="shenpi2">
            <i class="el-icon-chat-dot-square"></i>
            <span slot="title">企业帮填表单详情页</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu v-if="isAdmin" index="数据可视化">
          <template #title>
            <span>数据可视化</span>
          </template>
          <el-menu-item index="ShuJu">
            <i class="el-icon-message-solid"></i>
            <span slot="title">当日数据</span>
          </el-menu-item>
          <el-menu-item index="ShuJuOld">
            <i class="el-icon-chat-dot-square"></i>
            <span slot="title">往日数据</span>
          </el-menu-item>
        </el-submenu>

        <el-menu-item v-if="isAdmin" index="GeRen">
          <span slot="title">超管个人中心</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="TongXunLu">
            <i class="el-icon-s-shop"></i>
            <span slot="title">通讯录管理</span>
          </el-menu-item>
      </el-menu>
      
    </el-aside>
    <el-container>
      <el-header>小鹅科技-访客系统</el-header>
      <el-main>
        <!-- 核心在这，这里是路由的出口-->
        <router-view></router-view>
      </el-main>
      <!-- 底部区域 -->
      <el-footer>访客系统 ©2025 Created by 小鹅科技</el-footer>
    </el-container>
  </el-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      code: '',
      state: '',
      isAdmin: false, // 用户存储用户是否管理员
    };
  },

  mounted() {
    this.handleRedirect();

  },
  methods: {
    getUserRole() {
      // 从 localStorage 获取 token
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No token found in localStorage');
        return;
      }

      // 设置请求头中的 Authorization 字段
      this.$axios.get('/api/check_admin', {
        headers: {
          'Authorization': `${token}`
        }
      })
      .then(response => {
        // console.log('admin', response.data.data);
        if (response.data.data == 1) {
          this.isAdmin = true;
        } else if (response.data.data == 0) {
          this.isAdmin = false;
        }
      })
      .catch(error => {
        console.error('Error getting user role:', error);
      });
    },

    handleRedirect() {
      //卡片信息进入桌面端
      // const url = window.location.href;
      // console.log('urlllllllllllllllllllllll',url)
      // 创建 URL 对象
      // const urlObj = new URL(url);

      // // 获取查询参数中的 token 值
      // const token = urlObj.searchParams.get('token');

      // console.log(token); // 输出 token 值
      // if(token){
      //   localStorage.setItem('token',token)
      //   const token1 = localStorage.getItem('token');
      //       console.log('token1', token1);
      //       this.getUserRole();
      // }




      // 获取当前页面的完整链接
      // 获取哈希部分
      const hash = window.location.hash;
      // 使用正则表达式提取查询参数
      const matchCode = hash.match(/code=([^&]+)/);
      const matchState = hash.match(/state=([^&]+)/);
      const token = hash.match(/token=([^&]+)/);
        const token1 = token ? token[1] : null;
        // console.log('tokennnnnnnnnnnnnnnnnnnnnnn',token1)
        if(token1){
          localStorage.setItem('token',token1)
          // const token2 = localStorage.getItem('token');
              // console.log('token', token2);
              this.getUserRole();
        }
      // 赋值
      this.code = matchCode ? matchCode[1] : null;
      this.state = matchState ? matchState[1] : null;
      // console.log('Code:', this.code);
      // console.log('State:', this.state);


      // 获取 code 和 state 参数
      // const code = urlObj.searchParams.get('code');
      // const state = urlObj.searchParams.get('state');
      // this.code = code;
      // this.state = state;




        if (this.code && this.state) {
            // console.log('Code:', this.code);
            // console.log('State:', this.state);
	
            
        // 可以在这里发送这些参数到后端
        axios.post('https://fkxyuan.xiao-e.tech/api/redirect', { code: this.code, state: this.state })
          .then(response => {
            // console.log('Response:', response.data);
            // console.log('response.data.data:', response.data.data);
            //将response.data.data存入cookie中，后续调用其他api要将这个authorization放在头部发送给前端
            const token = response.data.data;
            // 将 token 存储在LocalStorage 中（或者 Vuex store 中）
            if(token!=null){
                    // 将 token 存储在LocalStorage 中（或者 Vuex store 中）
                    localStorage.setItem('token', token);
                    const token1 = localStorage.getItem('token');
                    console.log('token1', token1);
                  }
                  if(token==null){
                    console.log('空的token',localStorage.getItem('token'))
                  }
            
            this.getUserRole();
          })
          .catch(error => {
            console.error('Error:', error);
          });
      } else {
        this.getUserRole();
        console.error('Missing code or state parameter');
       
      }
    },

    changeSidebar(path) {
      // Check if the current path is different from the target path
      if (this.$route.path !== path) {
        this.$router.push(path); // Navigate to the new route
      }
    },
  }
};
</script>

<style scoped>
.el-aside__logo {
  height: 120px;
  background: url('@/assets/logoxiaoe.png') no-repeat center / 120px auto;
}
.el-container {
  height: 100vh; /* 使容器占满整个视口 */
}

.el-header {
  background-color: #fff;
  color: #333;
  font-size: 20px;
  text-align: left;
  line-height: 60px;
}

.el-aside {
  background-color: #304156;
  height: 100%; /* 侧边栏占据全部高度 */
}

.menu {
  height: 100%; /* 使菜单占据全部侧边栏高度 */
}

.el-main {
  background-color: #f5f7fc;
  color: #333;
  padding: 20px;
}
.el-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
}
</style>